import React from "react";
import { 
  FaCalendarAlt, 
  FaTools, 
  FaCheckCircle, 
  FaClock, 
} from "react-icons/fa";
function StatPerawatan({rows}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {/* Card Total Perawatan */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Total Perbaikan</p>
            <p className="text-2xl font-bold text-gray-900">{rows.length}</p>
          </div>
          <div className="p-3 bg-blue-100 rounded-lg">
            <FaTools className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </div>

      {/* Card Perawatan Selesai */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Selesai</p>
            <p className="text-2xl font-bold text-green-600">
              {rows.filter((item) => item.status === "selesai").length}
            </p>
          </div>
          <div className="p-3 bg-green-100 rounded-lg">
            <FaCheckCircle className="w-6 h-6 text-green-600" />
          </div>
        </div>
      </div>

      {/* Card Perawatan Dalam Proses */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Dalam Proses</p>
            <p className="text-2xl font-bold text-blue-600">
              {rows.filter((item) => item.status === "proses").length}
            </p>
          </div>
          <div className="p-3 bg-blue-100 rounded-lg">
            <FaClock className="w-6 h-6 text-blue-600" />
          </div>
        </div>
      </div>

      {/* Card Perawatan Dijadwalkan */}
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Dijadwalkan</p>
            <p className="text-2xl font-bold text-yellow-600">
              {rows.filter((item) => item.status === "terjadwal").length}
            </p>
          </div>
          <div className="p-3 bg-yellow-100 rounded-lg">
            <FaCalendarAlt className="w-6 h-6 text-yellow-600" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatPerawatan;
